import ReactGA from "react-ga4";

const TRACKING_ID = "G-VLBXBTQ256"; // Replace with your Google Analytics ID
ReactGA.initialize(TRACKING_ID);

export const trackPageView = () => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};

